module.exports = __webpack_public_path__ + "img/117.6.d3686ed4.png";